import axios from 'axios'

export const listNotificationsApi = ({ ownerId }) => {
  return axios.get(
    `${process.env.REACT_APP_BE_URL}/notifications`,
    { params: { ownerId } }
  )
}
